import React, { useState } from 'react';
import { Layout, Typography, Card, Row, Col, Button, Tabs, Pagination } from 'antd';
import { FaPalette, FaUpload } from 'react-icons/fa';

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const themesData = {
    "AI & Tech": [
        { name: "AI Dashboard", creator: "John Doe", price: "$25" },
        { name: "Machine Learning UI", creator: "Jane Smith", price: "$30" },
        { name: "AI Blog Template", creator: "Michael Johnson", price: "$20" },
        { name: "Tech Startup Theme", creator: "Sarah Lee", price: "$35" }
    ],
    "Cybersecurity": [
        { name: "Security Dashboard", creator: "James Brown", price: "$40" },
        { name: "Encrypted Chat UI", creator: "Emma Wilson", price: "$22" },
        { name: "Firewall Monitoring Theme", creator: "David Clark", price: "$28" }
    ],
    "Data Science": [
        { name: "Data Analytics Dashboard", creator: "Olivia Taylor", price: "$45" },
        { name: "Big Data UI Kit", creator: "William Martinez", price: "$32" }
    ],
    "Business & Education": [
        { name: "Online Course Theme", creator: "Sophia Anderson", price: "$38" },
        { name: "Business Analytics Template", creator: "Liam White", price: "$29" }
    ]
};

const pageSize = 4;

function SellYourThemes() {
    const [currentTab, setCurrentTab] = useState("AI & Tech");
    const [currentPage, setCurrentPage] = useState(1);

    const themes = themesData[currentTab] || [];
    const paginatedThemes = themes.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: '60px', background: 'linear-gradient(135deg, #e6fffb, #fff7e6)', minHeight: '100vh' }}>
                <Title level={2} style={{ fontSize: '20px', color: '#13c2c2', textAlign: 'center', fontWeight: '700', marginBottom: '28px' }}>
                    <FaPalette style={{ marginRight: '14px', fontSize: '20px', color: '#fa8c16' }} /> Sell Your Themes
                </Title>
                <Paragraph style={{ fontSize: '16px', color: '#595959', textAlign: 'center', marginBottom: '32px', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto', lineHeight: '1.6' }}>
                    Unleash your creativity on JectHub! Upload and sell your custom themes, or explore a vibrant collection tailored for AI, Cybersecurity, Data Science, and more.
                </Paragraph>
                <Button
                    type="primary"
                    icon={<FaUpload style={{ marginRight: '8px' }} />}
                    style={{
                        background: 'linear-gradient(45deg, #52c41a, #389e0d)',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        height: '48px',
                        padding: '0 24px',
                        fontSize: '16px',
                        display: 'block',
                        margin: '0 auto 32px',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'linear-gradient(45deg, #389e0d, #237804)';
                        e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'linear-gradient(45deg, #52c41a, #389e0d)';
                        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                    }}
                >
                    Upload Your Theme
                </Button>

                <Tabs
                    defaultActiveKey="AI & Tech"
                    onChange={(key) => { setCurrentTab(key); setCurrentPage(1); }}
                    centered
                    tabBarStyle={{ fontWeight: '700', color: '#13c2c2', borderBottom: '3px solid #13c2c2' }}
                >
                    {Object.keys(themesData).map(category => (
                        <TabPane tab={<strong>{category}</strong>} key={category}>
                            <Row gutter={[24, 24]} justify="center">
                                {paginatedThemes.map((theme, index) => (
                                    <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                        <Card
                                            hoverable
                                            style={{
                                                borderRadius: '16px',
                                                overflow: 'hidden',
                                                boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                                                background: 'linear-gradient(135deg, #ffffff, #f0fafa)',
                                                padding: '24px',
                                                height: '280px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                transition: 'transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-10px)';
                                                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
                                                e.currentTarget.style.background = 'linear-gradient(135deg, #f0fafa, #e6fffb)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.15)';
                                                e.currentTarget.style.background = 'linear-gradient(135deg, #ffffff, #f0fafa)';
                                            }}
                                        >
                                            <div>
                                                <Title level={4} style={{ color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                                                    {theme.name}
                                                </Title>
                                                <Paragraph style={{ color: '#595959', fontSize: '14px', marginBottom: '8px' }}>
                                                    <strong style={{ color: '#13c2c2' }}>Creator:</strong> {theme.creator}
                                                </Paragraph>
                                                <Paragraph style={{ color: '#595959', fontSize: '14px', marginBottom: '16px' }}>
                                                    <strong style={{ color: '#13c2c2' }}>Price:</strong> <span style={{ color: '#fa8c16', fontWeight: 'bold' }}>{theme.price}</span>
                                                </Paragraph>
                                            </div>
                                            <Button
                                                type="primary"
                                                style={{
                                                    background: 'linear-gradient(45deg, #fa8c16, #d46b08)',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    fontWeight: 'bold',
                                                    height: '44px',
                                                    width: '100%',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.background = 'linear-gradient(45deg, #d46b08, #ad4e00)';
                                                    e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.background = 'linear-gradient(45deg, #fa8c16, #d46b08)';
                                                    e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                                                }}
                                            >
                                                Buy Now
                                            </Button>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                            <Pagination
                                current={currentPage}
                                total={themes.length}
                                pageSize={pageSize}
                                onChange={setCurrentPage}
                                style={{ marginTop: '32px', textAlign: 'center', fontSize: '16px' }}
                                showSizeChanger={false}
                            />
                        </TabPane>
                    ))}
                </Tabs>

                {/* Custom CSS */}
                <style jsx global>{`
                    .ant-card {
                        animation: fadeIn 0.5s ease-in-out;
                    }
                    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
                        color: #13c2c2 !important;
                    }
                    .ant-tabs-ink-bar {
                        background: #13c2c2 !important;
                    }
                    .ant-pagination-item-active {
                        border-color: #fa8c16 !important;
                    }
                    .ant-pagination-item-active a {
                        color: #fa8c16 !important;
                    }
                    @keyframes fadeIn {
                        0% { opacity: 0; transform: translateY(10px); }
                        100% { opacity: 1; transform: translateY(0); }
                    }
                `}</style>
            </Content>
        </Layout>
    );
}

export default SellYourThemes;